import {ScribbleData} from '@docma-mm-core/scribble/scribble';
import {AnnoTypeEnum, ScribbleAnnotation, Size, TextAnnotation} from '@mydocma/component-library/src/lib/annotation';
import {getOpacityFromARGB, toARGB, toRGB} from './converter';

export class RectangleConverter {

  /* COMPONENT MODEL TO SCRIBBLE */
  static convertToData(anno: ScribbleAnnotation, containerSize: Size): ScribbleData {
    const points = anno.points;
    const xs = points.filter((_, i) => i % 2 === 0);
    const ys = points.filter((_, i) => i % 2 === 1);
    const strokeWidth = anno.style?.stroke?.width ?? 3;
    const halfStroke = strokeWidth / 2;
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    const adjustedMinX = minX - halfStroke;
    const adjustedMaxX = maxX + halfStroke;
    const adjustedMinY = minY - halfStroke;
    const adjustedMaxY = maxY + halfStroke;

    const width = adjustedMaxX - adjustedMinX;
    const height = adjustedMaxY - adjustedMinY;

    const shiftedPoints: number[] = [];
    for (let i = 0; i < points.length; i += 2) {
      shiftedPoints.push(points[i] - adjustedMinX);
      shiftedPoints.push(points[i + 1] - adjustedMinY);
    }

    const stageWidth = containerSize.width;
    const stageHeight = containerSize.height;

    const relX = adjustedMinX / stageWidth;
    const relY = adjustedMinY / stageHeight;
    const relW = width / stageWidth;
    const relH = height / stageHeight;

    return {
      UniqueId: anno.id,
      RelativeBasePointToParentPositionX: relX + (relW * 0.5),
      RelativeBasePointToParentPositionY: relY + (relH * 0.33),
      RelativeScaleX: relW,
      RelativeScaleY: relH,

      RelativeAnchorToParentPositionX: 0,
      RelativeAnchorToParentPositionY: 0,

      RelativeAnchorToCanvasPositionX: 0.5,
      RelativeAnchorToCanvasPositionY: 0.5,
      RelativeTextBoxToCanvasOffsetX: 0.5,
      RelativeTextBoxToCanvasOffsetY: 0.33,
      TextBoxAlignmentValue: 32,

      ScribblePath: shiftedPoints.join(','),
      PinShape: anno.type,

      BorderColorValue: toARGB(anno.style?.stroke?.color ?? '#0000FFFF', anno.style?.stroke?.opacity),
      BorderWidth: anno.style?.stroke?.width ?? 3,
      FillColorValue: anno.style.fillColor ?? '#FFFFFF00',
    } as ScribbleData;
  }

  /* SCRIBBLE TO COMPONENT MODEL */
  static convertToModel(scribble: ScribbleData, container: Size): TextAnnotation {
    const width = (scribble.RelativeScaleX || 0) * container.width;
    const left = container.width * scribble.RelativeBasePointToParentPositionX - (scribble.RelativeAnchorToCanvasPositionX || 0) * width;
    const height = (scribble.RelativeScaleY || 0) * container.height;
    const top = container.height * scribble.RelativeBasePointToParentPositionY - (scribble.RelativeAnchorToCanvasPositionY || 0) * height;
    // const fillOpacity = (scribble.TextBoxBackgroundColorValue ? getOpacityFromARGB(scribble.TextBoxBackgroundColorValue) : 1);

    return {
      text: scribble?.Text,
      type: scribble.PinShape,
      id: scribble.UniqueId,
      style: {
        fillColor: (scribble.FillColorValue ? toRGB(scribble.FillColorValue) : null), // (!scribble.TextBoxBackgroundColorValue || fillOpacity === 0 ? null : toRGB(scribble.TextBoxBackgroundColorValue))
        text: {
          size: scribble.TextBoxFontSize,
          color: toRGB(scribble.TextBoxFontColorValue)
        },
        stroke: {
          color: (scribble.BorderColorValue ? toRGB(scribble.BorderColorValue) : null),
          width: scribble.BorderWidth,
          opacity: scribble.PinShape === AnnoTypeEnum.Marker ? 0.7 : 1    // (scribble.strokeOpacity ?? 1)
        }
      },
      width,
      height,
      top,
      left
    } as TextAnnotation;
  }
}
